/** Digits only (for Danish 8-digit local numbers). */
export function loginV3DigitsOnly(value: string): string {
    return value.replace(/\D/g, '');
}

/**
 * True when the value should be treated as legacy phone login: exactly 8 digits,
 * optional spaces/hyphens only (no letters).
 */
export function loginV3IsEightDigitPhoneIdentifier(value: string): boolean {
    const trimmed = value.trim();
    if (!trimmed) return false;
    const digits = loginV3DigitsOnly(trimmed);
    if (digits.length !== 8) return false;
    return /^[\d\s-]+$/.test(trimmed);
}

/** Prefill password reset only when the login field looks like an email. */
export function loginV3LooksLikeEmail(value: string): boolean {
    const v = value.trim();
    return v.includes('@') && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
